/**
 * The `ch-grid-column-display` component is responsible for determining the
 * visibility of a grid column and updating its hidden property based on
 * whether the monitored class is visible or not.
 */
export class ChGridColumnDisplay {
    constructor() {
        this.column = undefined;
    }
    observer = new IntersectionObserver(() => {
        this.column.hidden = getComputedStyle(this.el).display === "none";
    });
    el;
    componentWillLoad() {
        this.observer.observe(this.el);
    }
    static get is() { return "ch-grid-column-display"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-column-display.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-column-display.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChGridColumnElement",
                    "resolved": "HTMLChGridColumnElement",
                    "references": {
                        "HTMLChGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The column element that is being monitored."
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-grid-column-display.js.map
